import React from 'react';
import MessageListAndToolsContainer from '@app/components/presentational/MessagingResponsive/MessageListAndTools/MessageListAndToolsContainer';
import { Dialog, DialogContent } from '@mui/material';

const ConversationView = (props) => {
  const { isConversationDialogOpen, handleConversationDialogClose } = props;

  return (
    <Dialog
      open={isConversationDialogOpen}
      onClose={handleConversationDialogClose}
      fullWidth
      maxWidth="md"
      aria-labelledby="conversation-dialog-title"
      aria-describedby="conversation-dialog-description"
      sx={{
        '& .MuiDialogContent-root': {
          padding: 0,
        },
      }}
    >
      <DialogContent>
        <MessageListAndToolsContainer />
      </DialogContent>
    </Dialog>
  );
};

export default ConversationView;
